
import { getEntityTypeById } from "../../../../api/gramjs/gramjsBuilders";
import { getActions, getGlobal } from "../../../../global";
import { getChatTitle, getUserFullName } from "../../../../global/helpers";


import React, { FC, memo, useState, useRef, useEffect, useSignal } from "../../../../lib/teact/teact";

import { MessageList } from "../../../../types";
import { copyTextToClipboard } from "../../../../util/clipboard";
// import parseMessageInput from "../../../../utils/parseMessageInput";

import Button from "../../../ui/Button";
import Modal from "../../../ui/Modal";
import ReportApi from "../../restapi/reportApi";
import store from "../../store";
import { parseMessageInput } from "../../telehook/telehookUtils";
import Snackbar from "../../ui/snackbar";

export type OwnProps = {
    isOpen: boolean;
    smss?: string[];
    smsCount?: number;
    getSmsByIndex?: (index: number) => string;
    onClose: () => void;
    onCopy: () => void;
}

const ChooseSmsDialog: FC<OwnProps> = (
    {
        isOpen,
        smss,
        smsCount,
        getSmsByIndex,
        onClose,
        onCopy,
    }
) => {
    const {
        sendMessage,
        clearDraft,
        showDialog,
        forwardMessages,
        openPollModal,
        closePollModal,
        loadScheduledHistory,
        openChat,
        addRecentEmoji,
        sendInlineBotResult,
        loadSendAs,
        resetOpenChatWithDraft,
        callAttachBot,
        addRecentCustomEmoji,
        showNotification,
        showAllowedMessageTypesNotification,
        openStoryReactionPicker,
        closeReactionPicker,
        sendStoryReaction,
    } = getActions();
    const [getHtml, setHtml] = useSignal('');
    const inputRef = useRef()
    const curContact = store.getState().contact.currentContact
    const smsList = smss || [];
    const totalSmsCount = smsCount ?? smsList.length;
    function getSmsAt(messageIndex: number): string {
        if (getSmsByIndex) {
            return getSmsByIndex(messageIndex);
        }
        return smsList[messageIndex] || "";
    }
    let index = Number(localStorage["smsIndex"])
    if (index == undefined) {
        index = 0
        localStorage["smsIndex"] = index
    }
    if (isNaN(index)) {
        index = 0;
        localStorage["smsIndex"] = index
    }

    if (index >= totalSmsCount && totalSmsCount > 0) {
        index = 0;
        localStorage["smsIndex"] = index;
    }
    const [state, setState] = useState({
        isOpen: false, index: Number(index),
        snackbarOpen: false,
        apiMessage: "",
        smsContent: getSmsAt(index)
    })
    function handleClose() {
        onClose()
    }
    function handleCopyCongNo() {
        copyTextToClipboard(state.smsContent)
        onClose()
        onCopy();
    }
    function showSnackbar(text: string) {
        setState(prev => ({ ...prev, snackbarOpen: true, apiMessage: text }))
    }
    function handleIndexChange(newIndex: number) {
        const sms = getSmsAt(newIndex)
        setState(prev => ({ ...prev, smsContent: sms }))
    }
    function handleSendTelegram() {
        const global = getGlobal()
        if (curContact) {
            const userId = curContact.tlUserId

            if (global.chats.byId[userId]) {
                const { text, entities } = parseMessageInput(getHtml());
                const messageList: MessageList = {
                    chatId: userId,
                    threadId: -1,
                    type: 'thread'
                }
                if (text.trim() != "") {
                    sendMessage({ messageList: messageList, text, entities, })
                    showSnackbar("Đã gửi tin nhắn tới " + global.chats.byId[userId].title)
                }
            } else {
                showSnackbar("Không tìm thấy hội thoại, hãy đảm bảo hội thoại tồn tại và đã cập nhật telegramID ở danh bạ")
            }
        }
    }
    function handleShareWebLink() {
        const curContact: any = store.getState().contact.currentContact
        if (!curContact)
            return
        const contactId = curContact.contactId
        ReportApi.getReportWebLink({ contactId }).then(res => {
            if (res) {
                const text = res.data;
                if (text != "") {
                    if (navigator.share) {

                        navigator.share({
                            title: 'Công nợ',
                            text: text,
                        })
                    } else {
                        copyTextToClipboard(text)
                        showSnackbar(`Đã copy liên kết báo cáo vào bộ nhớ,hãy gửi cho khách hàng \n ${text}`)
                    }

                }
            }
        })
    }
    useEffect(() => {
        const sms = getSmsAt(index)
        setHtml(sms)
        setState(prev => ({ ...prev, smsContent: sms }))
        if (inputRef.current)
            inputRef.current.innerHTML = sms
    }, [state.index, isOpen, totalSmsCount])
    return (
        <Modal isOpen={isOpen}
            onClose={handleClose}
            className="confirn"
        >
            <div className="form-header">
                <div className="form-header left-panel">
                    <Button
                        color="translucent"
                        round
                        size="smaller"
                        onClick={() => {
                            let newIndex = Number(state.index);
                            if (newIndex > 0)
                                newIndex -= 1;
                            setState((prev: any) => ({ ...prev, index: newIndex }))
                            localStorage["smsIndex"] = newIndex
                            handleIndexChange(newIndex)
                        }}>
                        <i className="fa-solid fa-backward"></i>
                    </Button>
                    <Button
                        color="translucent"
                        round
                        size="smaller"
                        onClick={() => {
                            let newIndex = Number(state.index);
                            if (newIndex < totalSmsCount - 1)
                                newIndex += 1;
                            setState((prev: any) => ({ ...prev, index: newIndex }))
                            localStorage["smsIndex"] = newIndex
                            handleIndexChange(newIndex)
                        }}>
                        <i className="fa-solid fa-forward"></i>
                    </Button>
                    {totalSmsCount > 0 && <div>
                        mẫu {(state.index + 1)} / {totalSmsCount}
                    </div>}
                    <div className="form-header right-panel">
                        <Button round
                            size="smaller"
                            color="translucent"
                            onClick={() => {
                                if (navigator.share) {
                                    let text = ""
                                    if (totalSmsCount > 0)
                                        text = getSmsAt(state.index)
                                    navigator.share({
                                        title: 'Công nợ',
                                        text: text,
                                    })
                                } else {
                                    showSnackbar('Trình duyệt của bạn không hỗ trợ tính năng chia sẻ')
                                }
                            }}
                        >
                            <i className="fa-solid fa-share"></i>
                        </Button>
                    </div>
                </div>
                <div className="form-header right-panel">

                    <Button round
                        size="smaller"
                        color="translucent"
                        onClick={handleShareWebLink}
                        disabled={state.snackbarOpen}
                    >
                        <i className="icon icon-share-screen-outlined"></i>
                    </Button>
                    <Button round
                        size="smaller"
                        color="translucent"
                        onClick={handleSendTelegram}
                        disabled={state.snackbarOpen}
                    >
                        <i className="icon icon-send"></i>
                    </Button>
                    <Button round
                        size="smaller"
                        color="translucent"
                        onClick={handleCopyCongNo}
                    >
                        <i className="fa-regular fa-copy"></i>
                    </Button>
                </div>
            </div>
            {
                totalSmsCount > 0 &&
                <div className='editable-div' contentEditable={true}
                    style={`height:70vh;;max-height:70vh;text-wrap:wrap;`}
                    onChange={(e) => {
                        const sms = e.target.textContent;
                        setHtml(e.target.innerHTML)
                        setState(prev => ({ ...prev, smsContent: sms }))
                    }}
                    ref={inputRef}
                ></div>
            }

            <Snackbar isOpen={state.snackbarOpen}
                message={state.apiMessage}
                onClose={() => { setState(prev => ({ ...prev, snackbarOpen: false })) }}
                triggerTime={JSON.stringify(new Date())}
            />
        </Modal>
    )
}
export default memo(ChooseSmsDialog)